import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      text:'',
      array:[]
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.editItem = this.editItem.bind(this);
    this.delObj = this.delObj.bind(this);
    this.clearAll = this.clearAll.bind(this);
  }


  onChange(e){
    this.setState({
      text:e.target.value
    })
  }

  onSubmit(e){
    e.preventDefault();
    if(this.state.text === ''){
      alert('Your input is empty')
    }else{
      this.setState({
        text:'',
        array:[...this.state.array,{id:this.state.text,text:this.state.text,done:false}]
      })
    }
  }

  handleCheck(itemId){
    let updatedArray = this.state.array.map(item => {
      if(item.id === itemId){
        item.done = !item.done;
      }
      return item;
    })
    this.setState({
      array:updatedArray
    })
    console.log(this.state.array);
  }

  editItem(itemId,itemText){
    const input = document.querySelector('input');
    input.focus();
    let newArray = this.state.array.filter(item => item.id !== itemId);
    this.setState({
      text:itemText,
      array:newArray
    })
    
  }

  delObj(itemId){
    const newArray = this.state.array.filter(item => item.id !== itemId);
    this.setState({
      array:newArray
    })
  }

  clearAll(){
    this.setState({
      array:[]
    })
  }

  render(){
    return(
      <div className='listContainer'>
        <h1>To-Do list with React</h1>
        <form onSubmit={this.onSubmit}>
          <input value={this.state.text} 
            onChange={this.onChange} placeholder='Type in your task...' 
            onFocus={e => e.target.placeholder =' '} 
            onBlur={e=> e.target.placeholder = 'Type in your task...'}/>
            <button>Submit</button>
        </form>
        
        <ul>
          {
            this.state.array.map(item => {
              return(
                <TodoItem key={item.id} id={item.id} text={item.text} status={item.done} handleCheck={this.handleCheck} editItem={this.editItem} onDelete={this.delObj}/>
              )
            })
          }
        </ul>
        <button onClick={this.clearAll} className='clearAll'>Clear all items</button>
      </div>
    )
  }
}



class TodoItem extends React.Component {
  constructor(props){
    super(props);
    this.checkItem = this.checkItem.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  checkItem(){
    this.props.handleCheck(this.props.id);
  }

  onEdit(){
    this.props.editItem(this.props.id,this.props.text);
  }

  deleteItem(){
    this.props.onDelete(this.props.id);
  }


  render(){
    let itemClass = this.props.status ? 'line' : '';
    return(
      <li>
        <span className={itemClass}>{this.props.text}</span>
        <div className='icons'>
          <i onClick={this.checkItem}  className="far fa-check-circle" style={{color:'#80cfa9'}}></i>
          <i onClick={this.onEdit}  className="far fa-edit" style={{color:'#11b5e4'}}></i>
          <i onClick={this.deleteItem} className="far fa-times-circle" style={{color:'#d21b1b'}}></i>
        </div>
      </li>
    )
  }
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
)